<template>
  <div class="logout">
    Vous avez déconnecté
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Logout",
  components: {},
  data() {
    return {
      showError: false
    };
  },
  mounted() {
    this.logoutUser()
  },
  methods: {
    ...mapActions(["LogOut"]),
    async logoutUser() {
      try {
        await this.LogOut()
        
        this.$router.push('/')
      }
      catch(error) {
        this.showError = true      
      }
    }
  }
}
</script>